var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',{attrs:{"type":"card"}},[_c('template',{slot:"header"},[_vm._v("process.env")]),_c('p',{staticClass:"d2-mt-0"},[_vm._v("NODE_ENV = "+_vm._s(_vm.env))]),_c('p',[_vm._v("BASE_URL = "+_vm._s(_vm.baseUrl))]),_c('p',{staticClass:"d2-mb-0"},[_vm._v("VUE_APP_TITLE = "+_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }